export const authRoutes = [
  // { path: `${process.env.PUBLIC_URL}/login`, Component: <Logins /> },
];
